import { StyleSheet } from 'react-native';
import { Colors } from '@shared/styles';

export const UnvalidatedStyles = {
  systemMessageIconSize: 16,
};

export const Styles = StyleSheet.create({
  // Note(fant): desired radius: 9px (but 1px border makes that 9+1px)
  stackedUserImage: {
    width: 20,
    height: 20,
    borderRadius: 10,
    borderWidth: 2,
    borderColor: 'white',
    overflow: 'hidden',
  },
  stackedUserImageSmall: {
    width: 14,
    height: 14,
    borderRadius: 7,
    borderWidth: 1,
    borderColor: 'white',
    overflow: 'hidden',
  },
  stackedUserOverlap: {
    marginLeft: -7,
  },

  stackedUserOverlapSmall: {
    marginLeft: -4,
  },

  systemMessageIcon: {
    width: UnvalidatedStyles.systemMessageIconSize,
    height: UnvalidatedStyles.systemMessageIconSize,
    borderRadius: UnvalidatedStyles.systemMessageIconSize / 2,
    overflow: 'hidden',
  },

  // Note: we hardcode the height of the delivery status. The reason is
  // that we want it to be equally tall no matter what content. When we
  // have text visible (eg "Delivered"), that is slightly higher (16px)
  // which makes the content jump a little when transitioning between
  // sending and sent/failed. This fixed height (which is as high as
  // the icon), solves that.
  deliveryStatusContent: {
    height: 16,
  },
  deliveryStatusIcon: {
    width: 10,
    height: 10,
    borderRadius: 5,
  },
  deliveryStatusText: {
    color: Colors.gray.normal,
    marginRight: 4,
  },
  deliveryStatusIconWaitingToSend: {
    opacity: 0.5,
  },
});
